import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActiveUserAvatarComponent } from '@app/shared/components/active-user-avatar/active-user-avatar.component';
import { TypingIndicatorComponent } from '@app/shared/components/typing-indicator/typing-indicator.component';
import { SharedModule } from '@app/shared/shared.module';
import { CollapsibleDrawerComponent } from './components/collapsible-drawer/collapsible-drawer.component';
import { DialogBroadcastMessageComponent } from './components/dialog-broadcast-message/dialog-broadcast-message.component';
import { DialogExtendGracePeriodComponent } from './components/dialog-extend-grace-period/dialog-extend-grace-period.component';
import { ResolvingThreadProgressComponent } from './components/resolving-thread-progress/resolving-thread-progress.component';
import { ThreadPageLevelMessagesComponent } from './components/thread-page-level-messages/thread-page-level-messages.component';
import { InboxRoutingModule } from './inbox-routing.module';
import { InboxComponent } from './pages/inbox/inbox.component';
import { ThreadComponent } from './pages/thread/thread.component';
import { ReservationHasGuestInsightsPipe } from './pipes/reservation-has-guest-insights.pipe';

@NgModule({
  declarations: [
    InboxComponent,
    ThreadComponent,
    DialogBroadcastMessageComponent,
    ResolvingThreadProgressComponent,
    ReservationHasGuestInsightsPipe,
    CollapsibleDrawerComponent,
    ThreadPageLevelMessagesComponent,
    DialogExtendGracePeriodComponent,
    ThreadComponent,
    ActiveUserAvatarComponent,
    TypingIndicatorComponent,
  ],
  imports: [CommonModule, SharedModule, InboxRoutingModule],
})
export class InboxModule {}
